export enum ApiErrors {
  UNAUTHORIZED = "Unauthorized",
  INSUFFICIENT_PERMISSIONS = "You do not have permission to perform this action.",
}
